import { render, staticRenderFns } from "./VersandaufteilungOverlay.vue?vue&type=template&id=003dd1f8&scoped=true&lang=html&"
import script from "./VersandaufteilungOverlay.vue?vue&type=script&lang=js&"
export * from "./VersandaufteilungOverlay.vue?vue&type=script&lang=js&"
import style0 from "./VersandaufteilungOverlay.vue?vue&type=style&index=0&id=003dd1f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003dd1f8",
  null
  
)

export default component.exports